export const authApis = {
  LOGIN: "/auth/admin/login",
  GET_PROFILE: "/admin",
};
